import { adminClient, jwtClient, magicLinkClient } from 'better-auth/client/plugins';
import { createAuthClient } from 'better-auth/react';

/**
 * Plugins must match the backend better-auth instance: jwt (Bearer token for the
 * backendFetcher), magicLink, admin. baseURL points at the backend's /api/auth mount.
 */
export const authClient = createAuthClient({
	baseURL: `${process.env.REACT_APP_BACKEND_WORKER_URL}/api/auth`,
	plugins: [jwtClient(), magicLinkClient(), adminClient()],
});
